import { UseFormReturn } from "react-hook-form";
import { TaskStatus } from "./definitions";
import { format } from "date-fns";

export const handleStatusChange = (
  newStatusString: string | undefined,
  previousStatus: string,
  formMethods: UseFormReturn<any>,
): string => {
  if (!newStatusString) {
    return previousStatus;
  }
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentStartDate = formMethods.watch("actualStartDateString");
  const currentCompletionDate = formMethods.watch("actualCompletionDateString");

  if (newStatusString === TaskStatus.NotStarted) {
    formMethods.setValue("actualStartDateString", "");
    formMethods.setValue("actualCompletionDateString", "");
  } else if (newStatusString === TaskStatus.InProgress) {
    if (!currentStartDate) {
      formMethods.setValue("actualStartDateString", currentDate);
    }
    formMethods.setValue("actualCompletionDateString", "");
  } else if (newStatusString === TaskStatus.Complete) {
    if (!currentStartDate) {
      formMethods.setValue("actualStartDateString", currentDate);
    }
    if (!currentCompletionDate) {
      formMethods.setValue("actualCompletionDateString", currentDate);
    }
  } else {
    // On hold, Pending customer action, Cancelled — preserve actualStart, clear completion.
    formMethods.setValue("actualCompletionDateString", "");
  }
  return newStatusString;
};
